export default __webpack_public_path__ + "static/media/Shelter-Animals-Count_Sample-Import.576f3f42.csv";